import { render, staticRenderFns } from "./TodoWindowView.vue?vue&type=template&id=35cd8c34&scoped=true&"
import script from "./TodoWindowView.vue?vue&type=script&lang=js&"
export * from "./TodoWindowView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cd8c34",
  null
  
)

export default component.exports